import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\LogoKryzalis.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\LogoKryzalis.vue?type=script"
import { render } from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\LogoKryzalis.vue?type=template"

script.render = render
export default script